import { Component, Input, OnInit, inject, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../data/language.service';
import { AuthService } from '../../../../core/authentication/auth.service';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { saveLanguageToStorage, getStoredLanguage, LANGUAGE_STORAGE_KEY } from '../../../../i18n/translation.config';
import { NgxSpinnerService } from 'ngx-spinner';

const STORAGE_EVENT = 'storage';

@Component({
  selector: 'app-navbar-choose-language',
  templateUrl: './navbar-choose-language.component.html',
  styleUrls: ['./navbar-choose-language.component.scss'],
  standalone: false
})
export class NavbarChooseLanguageComponent implements OnDestroy {
  translate = inject(TranslateService);
  private languageService = inject(LanguageService);
  private authService = inject(AuthService);
  private spinner = inject(NgxSpinnerService);
  private storageListener: any;

  @Input() readonly mode: 'white' | 'black' = 'black';

  constructor() {
    this.storageListener = (event: StorageEvent) => {
      if (event.key === LANGUAGE_STORAGE_KEY) {
        window.location.reload();
      }
    };
    window.addEventListener(STORAGE_EVENT, this.storageListener);
  }

  changeUserLanguage(language: string): void {
    const currentLanguage = getStoredLanguage() || 'pl';
    if (currentLanguage !== language) {
      saveLanguageToStorage(language);
      
      this.translate.use(language);
      this.spinner.show();
      
      if (this.authService.email) {
        this.languageService
          .changeLanguage(language)
          .pipe(
            switchMap(() => this.authService.refresh()),
            catchError(() => {
              this.spinner.hide();
              return of(null);
            }),
          )
          .subscribe((result) => {
            if (result) {
              window.location.reload();
            }
          });
      } else {
        window.location.reload();
      }
    }
  }

  ngOnDestroy() {
    window.removeEventListener(STORAGE_EVENT, this.storageListener);
  }
}
